import { Chip, ChipProps } from '@mui/material'

const StatusChip = ({ status, ...rest }: { status?: string } & ChipProps) => {
  const styleMap: Record<string, object | undefined> = {
    active: { color: 'success.main', backgroundColor: 'success.shades.4p' },
    'audible only': { color: 'success.main', backgroundColor: 'success.shades.4p' },
    relay: { color: 'success.main', backgroundColor: 'success.shades.4p' },
    online: { color: 'success.main', backgroundColor: 'success.shades.4p' },
    offline: { color: 'error.main', backgroundColor: 'error.shades.4p' },
    paused: { color: 'warning.main', backgroundColor: 'warning.shades.4p' },
    'not activated': { color: 'primary.dark', backgroundColor: 'primary.shades.4p' },
    extra: { color: 'primary.dark', backgroundColor: 'primary.shades.4p' },
    deactivated: { color: 'text.secondary', backgroundColor: 'action.hover' },
    inactive: { color: 'text.secondary', backgroundColor: 'action.hover' },
    invited: { color: 'primary.dark', backgroundColor: 'primary.shades.4p' },
    '': undefined,
  }

  const lookupKey = status?.toLowerCase() ?? (typeof rest.label === 'string' ? rest.label?.toLowerCase() : '')

  const style = { ...styleMap[lookupKey], ...rest.sx }

  return <Chip {...rest} sx={style} />
}

export default StatusChip
